import { JSX } from "react";

export const BarChart = (): JSX.Element => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0_1_4511"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="18"
                height="18"
            >
                <rect width="18" height="18" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_1_4511)">
                <path
                    d="M1.5 15.75V14.25H16.5V15.75H1.5ZM2.25 13.5V8.25H4.5V13.5H2.25ZM6 13.5V4.5H8.25V13.5H6ZM9.75 13.5V6.75H12V13.5H9.75ZM13.5 13.5V2.25H15.75V13.5H13.5Z"
                    fill="#1D2D58"
                />
            </g>
        </svg>
    );
};
